import AccionesAprendizProgramaCell from "@/components/AccionesTablas/AprendicesPrograma.acciones";
import type { AprendizPrograma } from "@interfaces/aprendizPrograma.interface";
import type { ColumnDef } from "@tanstack/react-table";

export const columns: ColumnDef<AprendizPrograma>[] = [
  {
    header: "ID",
    accessorKey: "id",
  },
  {
    header: "Aprendiz",
    cell: ({ row }) =>
      `${row.original.aprendiz.usuario.nombre} ${row.original.aprendiz.usuario.apellidoPaterno}`,
  },
  {
    header: "Programa",
    cell: ({ row }) => `${row.original.programa.nombre}`,
  },
  {
    header: "Progreso (%)",
    accessorKey: "progreso",
    cell: ({ getValue }) => `${getValue<number>()}%`,
  },
  // {
  //   header: "Creado por",
  //   accessorKey: "creadoPor",
  // },
  // {
  //   header: "Actualizado por",
  //   accessorKey: "actualizadoPor",
  // },
  {
    header: "Acciones",
    id: "acciones",
    cell: ({ row }) => {
      return <AccionesAprendizProgramaCell aprendizPrograma={row.original} />;
    },
  },
];

